/**
 * Google Ads tag (gtag.js). Loaded when VITE_GOOGLE_ADS_ID is set at build time.
 * Skipped on test.* hosts. See frontend/.env.example and scripts/deploy.sh (prod).
 */

const GTAG_SRC = 'https://www.googletagmanager.com/gtag/js'

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

export function getGoogleAdsId(): string | null {
  const id = import.meta.env.VITE_GOOGLE_ADS_ID?.trim()
  return id || null
}

function isTestHost(): boolean {
  if (typeof window === 'undefined') return false
  const host = window.location.hostname.toLowerCase()
  return host.startsWith('test.') || host === 'localhost' || host === '127.0.0.1'
}

function ensureDataLayer(): void {
  window.dataLayer = window.dataLayer || []
  if (typeof window.gtag === 'function') return
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer?.push(args)
  }
}

function injectGtagScript(adsId: string): void {
  const src = `${GTAG_SRC}?id=${encodeURIComponent(adsId)}`
  const scripts = Array.from(document.getElementsByTagName('script'))
  if (scripts.some((s) => s.src === src)) return

  const script = document.createElement('script')
  script.async = true
  script.src = src
  document.head.appendChild(script)
}

/** Load gtag.js and configure the Google Ads tag (all routes via main.tsx). */
export function initGoogleAdsTag(): void {
  const adsId = getGoogleAdsId()
  if (!adsId || typeof document === 'undefined' || isTestHost()) return

  ensureDataLayer()
  injectGtagScript(adsId)
  window.gtag?.('js', new Date())
  window.gtag?.('config', adsId)
}
